import { PlaceSearchInput, type PlaceSuggestion } from '@/modules/places/PlaceSearchInput';

interface CreatingPlaceViewProps {
  handleCancelCreate: () => void;
  handleCreateManually: () => void;
  form: { name: string; address: string };
  handlePlaceSelected: (suggestion: PlaceSuggestion) => void;
}

export function CreatingPlaceView({
  handleCancelCreate,
  handleCreateManually,
  form,
  handlePlaceSelected,
}: CreatingPlaceViewProps) {
  return (
    <div className="module module-places">
      <div className="module-accent-rail" style={{ background: 'var(--color-border)' }} />
      <div className="module-header">
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '0px', alignItems: 'center' }}>
          <button
            onClick={handleCancelCreate}
            style={{
              background: 'none',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              padding: '4px',
              paddingLeft: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
            }}
            title="Cancel"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: 'var(--color-text-muted)' }}
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </button>
          <button
            onClick={handleCreateManually}
            disabled={!form.name.trim()}
            style={{
              background: 'none',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
              opacity: !form.name.trim() ? 0.3 : 1,
            }}
            title="Create place"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: 'var(--color-text-muted)' }}
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>
        </div>
      </div>
      <div className="module-content">
        <div className="event-form">
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <PlaceSearchInput
              placeholder="Enter name to add place"
              onPlaceSelected={handlePlaceSelected}
              className="place-search"
              showZipCode={false}
            />
          </div>

        </div>
      </div>
    </div>
  );
}
